<template>
  <div style="overflow-x:clip;" v-swiper:ReviewSlider="settings">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <div class="relative text-center top-0  lg:hidden gallery-pagination swiper-pagination"></div>
</div>
  </div>
</template>
<script>
export default {
  name: 'ReviewSlider',
  data () {
    return {
      settings: {
        slidesPerView: 1,
        direction: "horizontal",
        loop: false,
        spaceBetween: 40,
        noSwiping: false,
        pagination: {
          clickable: true,
          el: '.swiper-pagination',
        },
        allowTouchMove: true,
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
            noSwiping: true,
            allowTouchMove: false,
          }
        }
      }
    }
  }
}
</script>
